import type {SafeHTMLString} from '@github-ui/safe-html'
import {VerifiedHTMLText} from '@github-ui/safe-html/VerifiedHTML'
import {Banner, Button} from '@primer/react'
import type React from 'react'

import {LABELS} from './constants/labels'
import styles from './UserRestrictedView.module.css'

type UserRestrictedViewProps = {
  reasonHTML?: SafeHTMLString | null
  children?: React.ReactNode
  issuesUrl?: string
}

export const UserRestrictedView = ({reasonHTML, children, issuesUrl}: UserRestrictedViewProps) => {
  const bannerContent = reasonHTML ? <VerifiedHTMLText html={reasonHTML} /> : (children ?? null)
  return (
    <div className={styles.userRestrictedContainer}>
      {bannerContent !== null && (
        <Banner aria-label="Warning" variant="warning" hideTitle title="Action restricted">
          <Banner.Description>{bannerContent}</Banner.Description>
        </Banner>
      )}
      {issuesUrl && (
        <Button as="a" href={issuesUrl} className={styles.backToAllIssuesButton}>
          {LABELS.backToAllIssues}
        </Button>
      )}
    </div>
  )
}
